export const ActionTypes = {
  LOADING: "ASSIGN_OPTION_CRITERIA_LOADING",
  ERROR: "ASSIGN_OPTION_CRITERIA_ERROR",
  SUCCESS: "ASSIGN_OPTION_CRITERIA_SUCCESS",
};
